"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group 319"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.66667 7.33301C3.03486 7.33301 3.33333 7.63148 3.33333 7.99967V13.9997H12.6667V7.99967C12.6667 7.63148 12.9651 7.33301 13.3333 7.33301C13.7015 7.33301 14 7.63148 14 7.99967V14.6663C14 15.0345 13.7015 15.333 13.3333 15.333H2.66667C2.29848 15.333 2 15.0345 2 14.6663V7.99967C2 7.63148 2.29848 7.33301 2.66667 7.33301Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0.666992 4.66667C0.666992 4.29848 0.965469 4 1.33366 4H14.667C15.0352 4 15.3337 4.29848 15.3337 4.66667V8C15.3337 8.36819 15.0352 8.66667 14.667 8.66667H1.33366C0.965469 8.66667 0.666992 8.36819 0.666992 8V4.66667ZM2.00033 5.33333V7.33333H14.0003V5.33333H2.00033Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_3",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M7.99967 4C8.36786 4 8.66634 4.29848 8.66634 4.66667V14.6667C8.66634 15.0349 8.36786 15.3333 7.99967 15.3333C7.63148 15.3333 7.33301 15.0349 7.33301 14.6667V4.66667C7.33301 4.29848 7.63148 4 7.99967 4Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_4",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.00033 2.00033C4.73511 2.00033 4.48076 2.10568 4.29322 2.29322C4.10568 2.48075 4.00033 2.73511 4.00033 3.00033C4.00033 3.26554 4.10568 3.5199 4.29322 3.70743C4.48076 3.89497 4.73511 4.00033 5.00033 4.00033H7.10301C7.02162 3.7874 6.9186 3.55327 6.79118 3.3216C6.37187 2.55922 5.79626 2.00033 5.00033 2.00033ZM8.00033 4.66699C8.65405 4.53625 8.654 4.53602 8.65395 4.53578L8.65384 4.53523L8.65357 4.53391L8.65285 4.53035L8.65061 4.51961C8.64876 4.51088 8.64621 4.49902 8.64291 4.48425C8.63631 4.45471 8.62672 4.41343 8.61388 4.36207C8.58824 4.2595 8.54943 4.11594 8.49526 3.9449C8.38769 3.6052 8.21587 3.14522 7.95947 2.67905C7.46211 1.77476 6.53773 0.666992 5.00033 0.666992C4.38149 0.666992 3.78799 0.912825 3.35041 1.35041C2.91282 1.78799 2.66699 2.38149 2.66699 3.00033C2.66699 3.61916 2.91282 4.21266 3.35041 4.65024C3.78799 5.08783 4.38149 5.33366 5.00033 5.33366H8.00033C8.20005 5.33366 8.38926 5.24411 8.51589 5.08965C8.64251 4.93519 8.69322 4.7321 8.65405 4.53625L8.00033 4.66699Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_5",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.04054 2.67905C8.53789 1.77476 9.46228 0.666992 10.9997 0.666992C11.6185 0.666992 12.212 0.912825 12.6496 1.35041C13.0872 1.78799 13.333 2.38149 13.333 3.00033C13.333 3.61916 13.0872 4.21266 12.6496 4.65024C12.212 5.08783 11.6185 5.33366 10.9997 5.33366H7.99968C7.79995 5.33366 7.61074 5.24411 7.48412 5.08965C7.35749 4.93519 7.30679 4.7321 7.34596 4.53625L7.99968 4.66699C7.34596 4.53625 7.34601 4.53602 7.34605 4.53578L7.34616 4.53523L7.34643 4.53391L7.34716 4.53035L7.3494 4.51961C7.35124 4.51088 7.3538 4.49902 7.3571 4.48425C7.3637 4.45471 7.37328 4.41343 7.38612 4.36207C7.41176 4.2595 7.45058 4.11594 7.50474 3.9449C7.61231 3.6052 7.78414 3.14522 8.04054 2.67905ZM8.897 4.00033H10.9997C11.2649 4.00033 11.5193 3.89497 11.7068 3.70743C11.8943 3.5199 11.9997 3.26554 11.9997 3.00033C11.9997 2.73511 11.8943 2.48075 11.7068 2.29322C11.5193 2.10568 11.2649 2.00033 10.9997 2.00033C10.2037 2.00033 9.62813 2.55922 9.20882 3.3216C9.08141 3.55327 8.97838 3.7874 8.897 4.00033ZM8.65317 4.79886C8.65314 4.79904 8.65314 4.79902 8.65319 4.79881L8.65317 4.79886Z",
    fill: fill
  })));
};

exports["default"] = _default;